import { useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store.type";
import MobilePopup from "../../newPopup/mobilePopup/MobilePopup";
import Loader from "../../loader/Loader";
import * as css from "./leadDetails.css";
import { XHR_LOADING_STATE } from "../../../assets/constants/constants";
import Btn from "../../button/btn/Btn";
import LeadItem from "./campaignItem/leadItem";
import { TWhatsappGroup } from "../../../redux/publish/publish.type";
import _ from "lodash";
import SummaryStats from "./SummaryStats/SummaryStats";
import CustomScrollbar from "../../customScrollbar/CustomScrollbar";
import { mobileMedia } from "../../../globalVariables/GlobalVariables";
import SearchLine from "../../search/SearchLine";


const LeadDetails = ({isOpen, onClose, leadName, adaptedData=null, showClass}) => {
    const {t} = useTranslation('publish');
    const [searchTerm, setSearchTerm] = useState('');
    const contentRef = useRef<HTMLDivElement>(null);
    const {data, getDataXHR} = useSelector((state: RootState) => ({
        data: adaptedData || state.publish.lead[leadName],
        getDataXHR: state.publish.lead[`${leadName}XHR`]
    }));

    const filteredData: TWhatsappGroup[] = useMemo(() => {
        if (!searchTerm.trim()) return data;
        return data?.filter(item => 
            item.name?.toLowerCase().includes(searchTerm.toLowerCase())
        ) || [];
    }, [data, searchTerm]);

    const dataKeysList = [
        { key: 'clicked', label: 'Entrances', suffix: '' },
        { key: 'purchased', label: 'transactions', suffix: '' },
        { key: 'tickets', label: 'tickets', suffix: '' },
        { key: 'revenue', label: 'sales', suffix: '₪' },
        { key: 'uniqueClicked', label: 'uniqueClicked', suffix: '' }
    ];
    const summaryData = filteredData ? filteredData.reduce((acc, item) => {
        dataKeysList.forEach(field => {
            if(field.key in item) {
                acc[field.key] = (acc[field.key] || 0) + Number(item[field.key]) || 0;
            }
        });
        return acc;
    }, {} as any) : {};
 
    if(!isOpen) return null;
    const popupProps = {
        cssStyle: 'height:75%; width:440px;',
        close: onClose,
        showClass: showClass,
        list: false,
        forwardRef: null,
    }

    if(getDataXHR === XHR_LOADING_STATE) {
        return (
            <MobilePopup
                {...popupProps}
                title={t(`${leadName}DetailsTitle`)} 
                dataCyName="lead-data-loading" >
                <Loader XHR={XHR_LOADING_STATE} height="200px" children={<></>} />
            </MobilePopup>
        );
    }

    if(!data || data.length === 0) {
        return (
            <MobilePopup 
                {...popupProps}
                title={t(`${leadName}DetailsTitle`)} 
                dataCyName="lead-data-empty" >
                <css.error>{t('noDataAvailable')}</css.error>
            </MobilePopup>
        );
    }
    const cssStyle = `
    inset-inline-end: -20px;
    ${mobileMedia}{
        display: none
    }
`;
    return (
        <css.popupWrapper>
        <MobilePopup 
            {...popupProps}
            title={t(`${leadName}DetailsTitle`)} 
            dataCyName="lead-details" >
            <css.content>
            <SearchLine 
                        filter={searchTerm}
                        setFilter={setSearchTerm}
                        title={t(`search${leadName}`)}
                        action={() => {}}
                        customCss={{
                            container: css.searchContainer,
                            input: css.searchInput
                        }}
                    />
                <CustomScrollbar contentRef={contentRef} cssStyle={cssStyle} />
                <css.scrollableContainer ref={contentRef}>
                <css.leadsList>
                    {filteredData.map((item, index) => <LeadItem dataKeys={dataKeysList} data={item} index={index} t={t}/>)}
                </css.leadsList>
                </css.scrollableContainer>
                <SummaryStats summaryKeysList={dataKeysList} summaryData={summaryData} t={t}/>
                <css.popupBottom>
                <Btn className='white' onClick={onClose}>
                    {t('close')}
                </Btn>
            </css.popupBottom>
            </css.content>
        </MobilePopup>
        </css.popupWrapper>
    );
};

export default LeadDetails;

